import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetofivejyotilingacab() {



    const cardData = {

keyword: "Pune to 5 Jyotirlinga Cab Package",

headingDescription:
    "Rising Cab Service offers a safe, comfortable, and well-organized Pune to 5 Jyotirlinga Cab Package for devotees and spiritual travelers. Our service includes well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, Mini Bus, and Luxury Urbania options with experienced chauffeurs for long-distance pilgrimage journeys. With doorstep pickup across Pune, flexible itinerary planning, one-way and round-trip packages, 24/7 support, and transparent pricing, we ensure a peaceful and hassle-free Jyotirlinga darshan experience covering major Shiva temples across Maharashtra and nearby states.",

topPlaces: [
    {
        title: "Trimbakeshwar Jyotirlinga (Nashik)",
        description:
            "Trimbakeshwar Jyotirlinga is one of the most sacred Shiva temples in India, located near Nashik. It is known for its unique three-faced lingam representing Brahma, Vishnu, and Mahesh. Surrounded by the Brahmagiri hills and the origin of the Godavari River, it is a powerful spiritual destination for devotees seeking blessings and moksha."
    },
    {
        title: "Bhimashankar Jyotirlinga (Pune District)",
        description:
            "Bhimashankar Jyotirlinga is located in the Sahyadri hills and is surrounded by dense forest and rich wildlife. It is one of the most visited Jyotirlingas near Pune and offers a peaceful spiritual environment along with scenic mountain views and trekking routes."
    },
    {
        title: "Aundha Nagnath Jyotirlinga (Hingoli)",
        description:
            "Aundha Nagnath Jyotirlinga is an ancient Shiva temple believed to be one of the oldest Jyotirlingas. It holds great historical and religious importance and attracts devotees from all over Maharashtra for its divine atmosphere and traditional architecture."
    },
    {
        title: "Parli Vaijnath Jyotirlinga (Beed)",
        description:
            "Parli Vaijnath Jyotirlinga is dedicated to Lord Shiva as the healer and is believed to cure diseases and provide health blessings. The temple is known for its spiritual energy, historical significance, and large number of devotees visiting throughout the year."
    },
    {
        title: "Grishneshwar Jyotirlinga (Aurangabad)",
        description:
            "Grishneshwar Jyotirlinga is the 12th Jyotirlinga located near the Ellora Caves. It is a UNESCO heritage region and one of the most important Shiva temples in India. The temple’s beautiful stone architecture and proximity to Ellora make it a major spiritual and heritage destination."
    },
    {
        title: "Ellora Caves (Optional Extension)",
        description:
            "Ellora Caves are a UNESCO World Heritage Site featuring ancient rock-cut temples dedicated to Hinduism, Buddhism, and Jainism. The Kailasa temple here is one of the largest monolithic structures in the world and is often included in Jyotirlinga tour packages."
    },
    {
        title: "Nashik Panchavati",
        description:
            "Panchavati in Nashik is a sacred area associated with Lord Ram’s exile period and includes important temples like Kalaram Temple and Sita Gufa. It is commonly visited along with Trimbakeshwar in pilgrimage circuits."
    },
    {
        title: "Shirdi Sai Baba Temple (Route Extension)",
        description:
            "Shirdi is a major spiritual destination dedicated to Sai Baba. Many devotees include Shirdi in extended Jyotirlinga packages for a complete spiritual journey from Pune covering both Shiva and Sai Baba blessings."
    },
    {
        title: "Ahmednagar Spiritual Route",
        description:
            "The Ahmednagar route connects several pilgrimage destinations and serves as a major travel corridor for Jyotirlinga tours. It offers smooth highway travel with multiple food and rest stops for long-distance cab journeys."
    },
    {
        title: "Konkan & Sahyadri Scenic Drive",
        description:
            "The Jyotirlinga circuit passes through scenic Sahyadri mountains, forest regions, and rural Maharashtra landscapes. The journey itself is spiritually enriching, making cab travel comfortable, peaceful, and memorable for devotees."
    }
],



services: [
{
name: "Pune to 5 Jyotirlinga Cab Package",
description: "Rising Cab Service offers Pune to 5 Jyotirlinga Cab Package for a complete spiritual journey covering major Jyotirlinga temples in Maharashtra. Enjoy a well-planned pilgrimage with comfortable AC cars, SUVs, Innova Crysta, and Tempo Traveller options. Our package includes experienced drivers, flexible itinerary, and door-to-door pickup for a smooth and devotional travel experience for families and groups."
},
{
name: "Pune to 5 Jyotirlinga Taxi Package",
description: "Book Pune to 5 Jyotirlinga Taxi Package for a safe and convenient religious tour covering multiple Jyotirlinga temples. We provide clean vehicles, professional chauffeurs, transparent pricing, and flexible travel schedules to ensure a stress-free pilgrimage experience from Pune."
},
{
name: "Pune to 5 Jyotirlinga Tour by Cab",
description: "Our Pune to 5 Jyotirlinga Tour by Cab is designed for devotees seeking a comfortable and organized temple tour. Travel across all major Jyotirlinga destinations with well-maintained vehicles, smooth driving, and complete support for a peaceful spiritual journey."
},
{
name: "Pune to 5 Jyotirlinga Cab Booking",
description: "Rising Cab Service provides easy Pune to 5 Jyotirlinga Cab Booking with multiple vehicle options, instant confirmation, and 24x7 customer support. Book online or via call for a hassle-free pilgrimage planning experience."
},
{
name: "5 Jyotirlinga Package from Pune by Car",
description: "Book 5 Jyotirlinga Package from Pune by Car for a personalized spiritual journey with private cab service. Enjoy flexible stops, comfortable seating, and safe travel to all Jyotirlinga temples at your own pace."
},
{
name: "Pune to 5 Jyotirlinga Taxi Tour",
description: "Our Pune to 5 Jyotirlinga Taxi Tour offers a complete devotional travel experience with experienced drivers, AC vehicles, and customized routes. Ideal for families and groups looking for a smooth pilgrimage journey."
},
{
name: "Pune to 5 Jyotirlinga Cab Service",
description: "Rising Cab Service provides reliable Pune to 5 Jyotirlinga Cab Service with clean cars, professional chauffeurs, and flexible travel plans. We ensure safe, comfortable, and devotional travel for all passengers."
},
{
name: "Pune to 5 Jyotirlinga Car Rental Package",
description: "Book Pune to 5 Jyotirlinga Car Rental Package for a private and comfortable temple tour. Choose from sedans, SUVs, and premium vehicles with experienced drivers and flexible travel options."
},
{
name: "Pune to 5 Jyotirlinga Cab Price",
description: "Get the best Pune to 5 Jyotirlinga Cab Price with affordable and transparent fare options. We offer budget-friendly packages based on vehicle type, itinerary, and travel duration."
},
{
name: "Pune to 5 Jyotirlinga Tour Cost",
description: "Rising Cab Service provides competitive Pune to 5 Jyotirlinga Tour Cost packages suitable for families and groups. Enjoy value-for-money pilgrimage travel with no hidden charges and full comfort."
},
{
name: "Pune to Bhimashankar Cab",
description: "Book Pune to Bhimashankar Cab for a comfortable and safe temple visit. Our service includes AC cars, experienced drivers, and door-to-door pickup for a smooth spiritual journey."
},
{
name: "Pune to Bhimashankar Taxi",
description: "Our Pune to Bhimashankar Taxi service ensures reliable and affordable travel to one of the most famous Jyotirlinga temples near Pune with well-maintained vehicles and professional chauffeurs."
},
{
name: "Pune to Bhimashankar Cab Booking",
description: "Rising Cab Service offers easy Pune to Bhimashankar Cab Booking with instant confirmation and multiple vehicle options for a hassle-free pilgrimage trip."
},
{
name: "Pune to Bhimashankar One Way Cab",
description: "Book Pune to Bhimashankar One Way Cab for convenient drop-only travel with comfortable AC vehicles and professional drivers at affordable rates."
},
{
name: "Pune to Bhimashankar Round Trip Taxi",
description: "Our Pune to Bhimashankar Round Trip Taxi service is ideal for same-day return visits with safe driving, flexible waiting options, and comfortable travel experience."
},
{
name: "Pune to Bhimashankar Darshan Cab",
description: "Rising Cab Service provides Pune to Bhimashankar Darshan Cab for devotees seeking a peaceful temple visit with safe, comfortable, and timely transportation."
},
{
name: "Pune to Bhimashankar Car Rental",
description: "Book Pune to Bhimashankar Car Rental for private travel with flexible stops, AC comfort, and professional chauffeurs ensuring a smooth journey."
},
{
name: "Pune to Bhimashankar Innova Cab",
description: "Our Pune to Bhimashankar Innova Cab is perfect for families and groups looking for extra comfort, spacious seating, and smooth hill travel experience."
},
{
name: "Pune to Bhimashankar Cab Fare",
description: "Get transparent Pune to Bhimashankar Cab Fare with affordable pricing based on vehicle type and travel options, ensuring budget-friendly pilgrimage travel."
},
{
name: "Pune to Bhimashankar Tour Package",
description: "Rising Cab Service offers Pune to Bhimashankar Tour Package for a complete spiritual journey with flexible itinerary, comfortable vehicles, and experienced drivers."
},
{
name: "Pune to Trimbakeshwar Cab",
description: "Book Pune to Trimbakeshwar Cab for a safe and comfortable Jyotirlinga temple visit with AC vehicles and professional drivers for a smooth journey."
},
{
name: "Pune to Trimbakeshwar Taxi",
description: "Our Pune to Trimbakeshwar Taxi service ensures reliable and affordable travel to Nashik’s famous Jyotirlinga temple with well-maintained cars and timely service."
}
],

tableData: [
["Pune to 5 Jyotirlinga Cab Package","Pune to 5 Jyotirlinga Taxi Package"],
["Pune to 5 Jyotirlinga Tour by Cab","Pune to 5 Jyotirlinga Cab Booking"],
["5 Jyotirlinga Package from Pune by Car","Pune to 5 Jyotirlinga Taxi Tour"],
["Pune to 5 Jyotirlinga Cab Service","Pune to 5 Jyotirlinga Car Rental Package"],
["Pune to Bhimashankar Cab","Pune to Bhimashankar Taxi"],
["Pune to Bhimashankar Cab Booking","Pune to Bhimashankar One Way Cab"],
["Pune to Bhimashankar Round Trip Taxi","Pune to Bhimashankar Darshan Cab"],
["Pune to Bhimashankar Innova Cab","Pune to Bhimashankar Tour Package"],
["Pune to Trimbakeshwar Cab","Pune to Trimbakeshwar Taxi"]
],




whychoose: [
    {
        WhyChooseheading: "Complete Pune to 5 Jyotirlinga Cab Package",
        WhyChoosedescription: "Rising Cab Service offers comfortable Pune to 5 Jyotirlinga cab packages for devotees, families, senior citizens, pilgrimage groups, and spiritual travelers."
    },
    {
        WhyChooseheading: "Visit Maharashtra's Sacred Jyotirlingas",
        WhyChoosedescription: "Our package covers Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath Jyotirlingas with well-planned travel arrangements."
    },
    {
        WhyChooseheading: "Customized Multi-Day Pilgrimage Tours",
        WhyChoosedescription: "Customers can choose flexible travel plans with customized itineraries, overnight stays, sightseeing options, and comfortable temple visits."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long-Distance Travel",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Urbania, and Mini Buses according to your group size."
    },
    {
        WhyChooseheading: "Perfect for Family and Religious Groups",
        WhyChoosedescription: "Our Jyotirlinga packages are ideal for family pilgrimages, senior citizen groups, temple tours, and spiritual travel across Maharashtra."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our professional drivers are familiar with Jyotirlinga routes and ensure safe, smooth, and comfortable travel throughout the pilgrimage."
    },
    {
        WhyChooseheading: "Hassle-Free Spiritual Journey",
        WhyChoosedescription: "Rising Cab Service handles transportation planning so devotees can focus completely on Darshan, worship, and spiritual experiences."
    }
]
};

const faqData = [
    {
        question: "Which Jyotirlingas are covered in the Pune to 5 Jyotirlinga package?",
        answer: "The package covers Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath Jyotirlingas."
    },
    {
        question: "How many days are required for the 5 Jyotirlinga tour?",
        answer: "Most devotees prefer a 3 to 5-day itinerary depending on Darshan schedules, sightseeing preferences, and travel plans."
    },
    {
        question: "Which vehicle is best for a family Jyotirlinga tour?",
        answer: "Ertiga and Innova Crysta are popular choices for families, while Tempo Travellers and Urbania are preferred for larger groups."
    },
    {
        question: "Can senior citizens comfortably travel on the Jyotirlinga route?",
        answer: "Yes, private cab travel provides flexibility, comfort, and convenience, making it suitable for senior citizens."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers, Urbania, and Mini Buses can be arranged for large groups and religious organizations."
    },
    {
        question: "Can Grishneshwar and Ellora Caves be visited together?",
        answer: "Yes, many travelers combine Grishneshwar Jyotirlinga Darshan with Ellora Caves and nearby attractions."
    },
    {
        question: "Can hotel accommodations be included in the package?",
        answer: "Yes, customized packages can include hotel stays, sightseeing options, and personalized travel arrangements."
    },
    {
        question: "Is advance booking recommended for Jyotirlinga tours?",
        answer: "Yes, advance reservations are recommended during Shravan month, Mahashivratri, holidays, and peak pilgrimage seasons."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, devotees can start their pilgrimage from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can I book a Pune to 5 Jyotirlinga Cab Package?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Prakash Deshmukh",
        feedback:
            "Our 5 Jyotirlinga pilgrimage was organized exceptionally well. The vehicle was comfortable, the itinerary was perfectly planned, and we completed all Darshans without any difficulty.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sunanda Kulkarni",
        feedback:
            "Traveling with elderly family members was very comfortable. The driver was knowledgeable about all temple routes, and the entire spiritual journey was peaceful and memorable.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to 5 Jyotirlinga Cab Package",
"image": "https://www.risingcabservice.com/assets/images/pune-to-5-jyotirlinga-cab.jpg",
"description": "Book Pune to 5 Jyotirlinga Cab Package with Rising Cab Service for a comfortable spiritual tour covering major Jyotirlinga temples. Ideal for family pilgrimage trips with safe AC cars, SUVs, and Innova options with experienced drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Custom Package",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-5-jyotirlinga-cab-package"
}
};





    return (
        <div>

<Helmet>
  <title>Pune to 5 Jyotirlinga Cab Package | Pilgrimage Tour Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to 5 Jyotirlinga Cab Package for a spiritual pilgrimage tour covering major Jyotirlinga temples. Comfortable AC cars, SUVs, and Innova available with experienced drivers."
/>

<meta
 name="keywords"
 content="pune to 5 jyotirlinga cab package, pune to 5 jyotirlinga taxi package, 5 jyotirlinga tour from pune by cab, pune to 5 jyotirlinga car rental package, pune to bhimashankar cab, pune to bhimashankar taxi, jyotirlinga tour pune cab, spiritual tour cab pune, pune pilgrimage cab package"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetofivejyotilingacab;